import axios from "axios";
import config from "../config";
const moduleApiEndPoint = config.mmApiHost;

// const storageApiEndPoint = "https://qa-storageapi.indegene.com";
 
// Default - Instance

export const instancemm = axios.create({

  baseURL: moduleApiEndPoint,

  timeout: 15000,
 
  // headers: { "X-Custom-Header": "foobar" },

});
 
instancemm.interceptors.request.use(

  function (config) {

    const token = window.localStorage.getItem("userToken");

    if (token) {

      config.headers["Authorization"] = "Bearer " + token;

    }

    return config;

  },

  function (error) {

    return Promise.reject(error);

  }

);
 
instancemm.interceptors.response.use(

  function (response) {

    return response;

  },

  function (error) {

    return Promise.reject(error);

  }

);
 
// Storage - Instance

export const instanceStorage = axios.create({

  baseURL: moduleApiEndPoint,

  timeout: 8000,

});
 
// Add a request interceptor

instanceStorage.interceptors.request.use(

  function (config) {

    const token = window.localStorage.getItem("userToken");

    if (token) {

      config.headers["Authorization"] = "Bearer " + token;

    }

    return config;

  },

  function (error) {

    return Promise.reject(error);

  }

);
 
// Add a response interceptor

instanceStorage.interceptors.response.use(

  function (response) {

    return response;

  },

  function (error) {

    return Promise.reject(error);

  }

);
 
// Upload - Instance

export const instanceUpload = axios.create({

  baseURL: moduleApiEndPoint,

  timeout: 60 * 4 * 1000,

});
 
// Add a request interceptor

instanceUpload.interceptors.request.use(

  function (config) {

    const token = window.localStorage.getItem("userToken");

    //  const token = "12345678dkdklsdf";

    if (token) {

      config.headers["Authorization"] = "Bearer " + token;

    }

    return config;

  },

  function (error) {

    return Promise.reject(error);

  }

);
 
// Add a response interceptor

instanceStorage.interceptors.response.use(

  function (response) {

    return response;

  },

  function (error) {

    return Promise.reject(error);

  }

);
 
// ImageConvert - Instance

// export const imageconvertInstance = axios.create({

//   baseURL: process.env.REACT_APP_IMAGE_CONVERT_API_URL,

//   timeout: 30000,

// });
 
// imageconvertInstance.interceptors.request.use(

//   function (config) {

//     const token = window.localStorage.getItem("userToken");

//     if (token) {

//       config.headers["Authorization"] = "Bearer " + token;

//       config.headers["x-environment"] = process.env.REACT_APP_ENV

//     }

//     return config;

//   },

//   function (error) {

//     return Promise.reject(error);

//   }

// );
 
// imageconvertInstance.interceptors.response.use(

//   function (response) {

//     return response;

//   },

//   function (error) {

//     return Promise.reject(error);

//   }

// );
 
 
export default instancemm;

 